import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import UserModule from './modules/user'
import EventModule from './modules/event'
// import EventBlockModule from './modules/eventBlock'
import TicketsetModule from './modules/ticketset'
import CheckpointModule from './modules/checkpoint'
import DeviceModule from './modules/device'
import TicketModule from './modules/ticket'
import StatisticsModule from './modules/statistics'

export default new Vuex.Store({
    modules: {
        user: UserModule,
        event: EventModule,
        // eventBlock: EventBlockModule,
        ticketset: TicketsetModule,
        checkpoint: CheckpointModule,
        device: DeviceModule,
        ticket: TicketModule,
        statistics: StatisticsModule
    },

    state: {
        config: {
            server: process.env.VUE_APP_ENV === 'dev' ? 'http://localhost:8000/' : '/',
            assetsDir: '/admin/',
            env: process.env.VUE_APP_ENV
        },
        storeError: false,
        storeErrorMessage: ''
    },
    mutations: {
        setTicketList(state, ticketList = null) {
            state.ticketList = ticketList
        },
        setTicketListPaging(state, paging) {
            state.ticketListPaging = paging
        },
        setStoreErrorMessage(state, message) {
            state.storeError = true
            state.storeErrorMessage = message
        },
        hideStoreError(state) {
            state.storeError = false
        }
    },
    actions: {
    }
})
